var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon16PxMoreVert(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99902 12C8.43896 12 8.79872 12.3599 8.79883 12.7998C8.79883 13.2398 8.43902 13.5996 7.99902 13.5996C7.55902 13.5996 7.19922 13.2398 7.19922 12.7998C7.19933 12.3599 7.55909 12 7.99902 12ZM7.99902 7.2002C8.43902 7.2002 8.79883 7.56 8.79883 8C8.79883 8.44 8.43902 8.7998 7.99902 8.7998C7.55902 8.7998 7.19922 8.44 7.19922 8C7.19922 7.56 7.55902 7.2002 7.99902 7.2002ZM7.99902 2.40039C8.43902 2.40039 8.79883 2.7602 8.79883 3.2002C8.79872 3.64011 8.43896 4 7.99902 4C7.55909 4 7.19933 3.64011 7.19922 3.2002C7.19922 2.7602 7.55902 2.40039 7.99902 2.40039Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon16PxMoreVert);
export default __webpack_public_path__ + "static/media/icon_16px_more-vert.da31d05e998d6579490c55cf9cee9333.svg";
export { ForwardRef as ReactComponent };